import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const PowerButtonSvg = () => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" width="24" height="24" viewBox="0 0 24 24">
    <g className="nc-icon-wrapper" fill="currentColor">
      <path fill="none" id="Frame_-_24px" d="M0 0h24v24H0z" />
      <g id="Line_Icons">
        <path
          d="M15 5.589v2.223A5.999 5.999 0 0 1 18 13c0 3.309-2.691 6-6 6s-6-2.691-6-6a5.998 5.998 0 0 1 3-5.188V5.589C6.072 6.779 4
          9.65 4 13c0 4.411 3.589 8 8 8s8-3.589 8-8c0-3.35-2.072-6.221-5-7.411z"
          fill="currentColor"
        />
        <path fill="currentColor" d="M11 3h2v8h-2z" />
      </g>
    </g>
  </svg>
);

const PowerButton = (props: IIconProps) => <Icon component={PowerButtonSvg} {...props} />;

export default PowerButton;
